/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RestoreGceDiskConfig {
  /**
  * The zone to restore the disk to
  */
  'zone'?: string;
  /**
  * The type of the disk to restore (e.g., pd-standard, pd-ssd, pd-balanced)
  */
  'diskType'?: string;
  /**
  * The size of the disk to restore in bytes
  */
  'diskSizeBytes'?: number;
  /**
  * Description to apply to the restored disk
  */
  'description'?: string;
  /**
  * Labels to apply to the restored disk
  */
  'labels'?: { [key: string]: string; };
  /**
  * Provisioned IOPS for the disk (only applicable for certain disk types)
  */
  'iops'?: number;
  /**
  * Disk throughput.
  */
  'throughput'?: number;
  /**
  * ID of the customer-managed encryption key to use for the disk
  */
  'encryptionKeyId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "zone",
      "baseName": "zone",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskType",
      "baseName": "diskType",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskSizeBytes",
      "baseName": "diskSizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "labels",
      "baseName": "labels",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "iops",
      "baseName": "iops",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "throughput",
      "baseName": "throughput",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "encryptionKeyId",
      "baseName": "encryptionKeyId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreGceDiskConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

